const turf = require('@turf/helpers')
const inside = require('@turf/boolean-point-in-polygon')
const { coordsDistance } = require('./utils')
const booleanPointInPolygon = require('@turf/boolean-point-in-polygon')
const distance = require('@turf/distance')
const pointToLineDistance = require('@turf/point-to-line-distance')

exports.insideGeofence = function insideGeofence (position, geofence) {
  const coords = geofence.area.slice(9, geofence.area.length - 2).split(',')
  const coords2 = coords.map(c => {
    return c.trim().split(' ').map(a => parseFloat(a))
  })
  const pt = turf.point([parseFloat(position.latitude), parseFloat(position.longitude)])
  const poly = turf.polygon([coords2])

  return inside.default(pt, poly)
}

exports.getNearestPOI = (position, geofences) => getNearestPOIs(position.longitude, position.latitude, geofences)[0]
function getNearestPOIs (long, lat, geofences) {
  const distance = geofences
    .filter(g => g && g.area && g.area.startsWith('CIRCLE'))
    .map(g => {
      const str = g.area.substring('CIRCLE ('.length, g.area.indexOf(','))
      const radius = g.area.substring(g.area.indexOf(',') + 1, g.area.indexOf(')'))
      const coord = str.trim().split(' ')
      return {
        p: g,
        distance: Math.round(coordsDistance(parseFloat(coord[1]), parseFloat(coord[0]), long, lat)),
        r: parseFloat(radius)
      }
    })
  return distance.filter(a => a.distance < a.r).sort((a, b) => (a.distance > b.distance) ? 1 : -1)
}
exports.getNearestPOIs = getNearestPOIs

exports.loadGroupsData = async function loadGroupsData (userData, traccarInstance) {
  for (const g of userData.groups) {
    g.geofenceIds = (await traccarInstance.geofences.geofencesGet(undefined, undefined, undefined, g.id, undefined, undefined).then(r => r.data)).map(g => g.id)
  }
}

exports.checkGeofenceIn = function checkGeofenceIn (p, g) {
  switch (g.geometry.type) {
    case 'Polygon':
      return booleanPointInPolygon.default(p, g)
    case 'Point':
      return distance.default(p, g, { units: 'meters' }) <= g.properties.distance
    case 'LineString':
      return pointToLineDistance.default(p, g, { units: 'meters' }) < (g.properties.geofence.attributes.polylineDistance || 25)
  }
}
